import { sanitizeInput } from '../utils';

import { type ConfluenceSearchPageResult, type ConfluenceSearchResultWithLinks } from './types';
import { getConfluencePageSearchURL } from './utils';

const IGNORE_MAU_HEADER = 'x-atlassian-mau-ignore';

export const searchConfluencePages = async ({
	searchString,
	cloudId,
	gatewayBaseUrl = '',
}: {
	searchString?: string;
	cloudId: string;
	gatewayBaseUrl?: string;
}): Promise<ConfluenceSearchResultWithLinks> => {
	let cqlQuery: string;
	if (searchString) {
		cqlQuery = `type=page and title ~ "${sanitizeInput(searchString)}"`;
	} else {
		cqlQuery = `type=page`;
	}

	const response = await fetch(getConfluencePageSearchURL({ cqlQuery, cloudId, gatewayBaseUrl }), {
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
			[IGNORE_MAU_HEADER]: 'true',
		},
	});

	if (!response.ok) {
		throw response;
	}

	return response.json();
};

/**
 * Search Confluence Page by Id
 * API doc at: https://developer.atlassian.com/cloud/confluence/rest/v2/api-group-page/#api-pages-id-get
 */
export const searchConfluencePage = async ({
	cloudId,
	defaultParentId,
	gatewayBaseUrl = '',
}: {
	cloudId: string;
	defaultParentId: string;
	gatewayBaseUrl?: string;
}): Promise<ConfluenceSearchPageResult> => {
	const response = await fetch(
		`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/pages/${defaultParentId}`,
		{
			method: 'GET',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);

	if (!response.ok) {
		throw response;
	}

	return response.json();
};
